import { render, staticRenderFns } from "./Interactive.vue?vue&type=template&id=2b6456f8&"
import script from "./Interactive.vue?vue&type=script&lang=js&"
export * from "./Interactive.vue?vue&type=script&lang=js&"
import style0 from "./Interactive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports